import Layout from "components/layout";
import Image from "next/image";

import { resetScroll } from "utils/browser";

import { useState } from "react";
import { useMounted } from "hooks/react";

export default function AppPage(): JSX.Element {
  const [device, setDevice] = useState("Android");

  useMounted(() => {
    resetScroll();

    let nativeDevice: string;
    if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) {
      nativeDevice = "iOS";
    }
    if (navigator.userAgent.match(/android/i)) {
      nativeDevice = "Android";
    }
    setDevice(nativeDevice || "Android");
  });

  function toggleDevice() {
    setDevice((prevDevice) => {
      return prevDevice === "Android" ? "iOS" : "Android";
    });
  }

  return (
    <Layout
      title="Aplicativo"
      description="Baixe agora o aplicativo para smartphones do Vstiba e tenha seus estudos na palma da mão."
      canonical="/aplicativo"
    >
      <main>
        <div className="container">
          <div className="small-container">
            <header className="mb-8">
              <h1 className="mb-4">Aplicativo</h1>
              <p>Salve o Vstiba na sua tela inicial</p>
            </header>

            <div className="mt-4">
              <div className="flex items-start justify-between w-full">
                <h3>{device}</h3>
                <span
                  className="px-2 border border-2 border-black-100 rounded-md cursor-pointer"
                  onClick={toggleDevice}
                >
                  {device === "Android" ? "iOS" : "Android"}
                </span>
              </div>

              {device === "Android" && (
                <p className="mb-4">
                  <span className="block mb-2">Baixe agora</span>
                  <span className="block mb-1 text-emphasis-medium">
                    Afim de reservar um espacinho para o Vstiba na tela inicial
                    do seu celular Android? É só clicar no link abaixo :)
                  </span>
                </p>
              )}

              <Installation device={device} />
            </div>

            {device === "iOS" && (
              <div>
                <div className="flex justify-center">
                  <video
                    src="/iphone-app-download-instructions.mp4"
                    width={650}
                    height={1200}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="rounded-lg"
                    title="Instruções para instalação do aplicativo no iPhone"
                  />
                </div>

                <p className="mb-4">
                  <span className="block mb-2">
                    Por que o aplicativo não está na App store?
                  </span>
                  <span className="block mb-1 text-emphasis-medium">
                    O aplicativo do Vstiba é uma versão do site otimizada para
                    celular que você pode salvar na sua tela inicial.
                  </span>
                  <span className="block text-emphasis-medium">
                    Optamos por não colocar o aplicativo na App store porque o
                    download pelo site é muito mais leve, o que economiza o seu
                    plano de dados, o seu tempo e o espaço disponível no seu
                    celular.
                  </span>
                </p>

                <p>
                  <span className="block mb-2">O download é seguro?</span>
                  <span className="block text-emphasis-medium">
                    Sim! O aplicativo é instalado e adicionado a tela inicial
                    automaticamente pelo próprio navegador e é muito mais leve e
                    rápido do que baixar um aplicativo da loja de apps.
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>
      </main>
    </Layout>
  );
}

function Installation({ device }) {
  const iosInstructions = [
    "Toque no ícone de compartilhamento do navegador",
    'Escolha a opção "Adicionar à Tela de início"'
  ];

  return (
    <>
      {device == "iOS" && (
        <div>
          <ol className="pl-4 list-decimal">
            {iosInstructions.map((instruction: string) => {
              return (
                <li key={instruction} className="mb-1">
                  {instruction}
                </li>
              );
            })}
          </ol>

          <p className="text-primary-800">
            Pronto! Agora você pode usar o aplicativo normalmente, clicando no
            ícone na tela inicial do seu celular
          </p>
        </div>
      )}

      {device === "Android" && (
        <div className="-ml-3">
          <a href="https://play.google.com/store/apps/details?id=com.vstiba.www.twa&utm_source=website&utm_campaign=landing_page&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
            <Image
              alt="Disponível no Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png"
              width={193}
              height={75}
            />
          </a>
        </div>
      )}
    </>
  );
}
